// import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

// in production, the widget extensions are included in the chunks created for widgets
if (!IS_PRODUCTION) {
    // load all widget extensions. They could be loaded individually instead
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

setPostStyleGuideTheme({
    colors: {
        primary: {
            main: "#FFCC33",
        },
        danger: {
            main: "#e02b27",
            contrast: "#FFFFFF",
        },
    },
    typography: {
        fontFamilyImportUrl: "/staticContent/styleSheet.css",
        body: {
            fontFamily: "Gotham A,Gotham B",
        },
        h1: {
            weight: 400,
            size: "32px",
            lineHeight: "1.5rem",
        },
        h2: {
            weight: 400,
            size: "18px",
            lineHeight: "1.5rem",
        },
        h3: {
            weight: 400,
            size: "20px",
            lineHeight: "1.5rem",
        },
        h4: {
            weight: 700,
            size: "24px",
            lineHeight: "1.5rem",
        },
        h5: {
            weight: 500,
            size: "16px",
            lineHeight: "1.5rem",
        },
        h6: {
            weight: 700,
            size: "16px",
            lineHeight: "1.5rem",
        },
    },
    link: { defaultProps: { icon: { iconProps: { color: "secondary", size: 48 } } } },
    accordion: {
        defaultProps: {
            css: css`
                button {
                    
                }
            `,
        },
    },
    button: {
        primary: {
            color: "primary",
            css: css`
                border: 2px solid #ffcc33;
				&:focus {
                        border-color: none;
                        border-style: unset;
                        border-width: 0;
                    }
            `,
            hoverMode: "lighten",
            sizeVariant: "medium",
        },
        secondary: {
            color: "#323031",
            hoverMode: "lighten",
            sizeVariant: "medium",
        },
    },
    formField: {
        defaultProps: {
            border: "underline",
            backgroundColor: "common.accent",
        },
    },
    dataTable: {
        defaultProps: {
            cssOverrides: {
                table: css`
                    border: 2px solid cyan;
                `,
            },
        },
    },
    breadcrumbs: {
        defaultProps: {
            css: css`
                font-style: italic;
                text-decoration: underline;
            `,
        },
    },
    zIndex: {
        tabGroup: 1000,
    },
    
});
